import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StorageService} from '../../shared/services/storage.service';
import {ConsultantService} from '../../shared/services/consultant.service';
import {DoctorService} from '../../shared/services/doctor.service';

@Component({
    selector: 'app-consultants',
    templateUrl: './consultants.component.html',
    styleUrls: ['./consultants.component.scss']
})
export class ConsultantsComponent implements OnInit {
    doctorForm: FormGroup;
    doctorsData = [];
    consultantId: any;
    showSearch = false;
    consultants = [];
    id: any;
    data: any;
    updatePasswordForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    user: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private consultantService: ConsultantService,
                private doctorService: DoctorService) {
        this.user = StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.updatePasswordForm = this.fb.group({
            'password': ['']
        });
        this.searchForm = this.fb.group({
            'name': [''],
            'username': [''],
            'email': [''],
            'contact': [''],
        });
        this.doctorForm = this.fb.group({
            'doctors_details_id': ['', Validators.required],
        });
        this.get();
        this.getDoctors();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-consultant').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    updatePasswordModal(content, id) {
        this.id = id;
        this.updatePasswordForm.patchValue({
            'password': ''
        });
        this.modalService.open(content, {'size': 'sm'});
    }

    patchForm(data) {
        this.doctorForm.patchValue({
            doctors_details_id: (data && data?.consultant_detail?.doctors_details_id) ? data?.consultant_detail?.doctors_details_id : '',
        });
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.consultants = [];
        this.consultantService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.consultants = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.consultants = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getDoctors(params: any = {}) {
        this.doctorService.get(params).subscribe(data => {
            this.doctorsData = data['data'];
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'email': (this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
            'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
        };
        this.get(params);
    }

    updatePassword() {
        this.submitted = true;
        if (!this.updatePasswordForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'password': (this.updatePasswordForm.value && this.updatePasswordForm.value.password) ? this.updatePasswordForm.value.password : ''
            };
            this.submitting = true;
            this.consultantService.updatePassword(this.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.updatePasswordForm.patchValue({
                    'password': '',
                });
                this.modalService.dismissAll('');
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm && this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'email': (this.searchForm && this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
            'contact': (this.searchForm && this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.consultantService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    openModal(data: any, doctorModal) {
        this.consultantId = data?.id;
        this.patchForm(data);
        this.modalService.open(doctorModal, {ariaLabelledBy: 'modal-basic-title'});
    }

    assignDoctor() {
        this.submitted = true;
        if (!this.doctorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'doctors_details_id': (this.doctorForm && this.doctorForm.getRawValue() && this.doctorForm.getRawValue().doctors_details_id) ? this.doctorForm.getRawValue().doctors_details_id : '',
            };
            this.consultantService.assign_doctor(this.consultantId, params).subscribe(data => {
                this.submitted = false;
                this.doctorForm.patchValue({
                    'doctors_details_id': '',
                });
                this.get();
                this.modalService.dismissAll();
            }, error => {
                console.log(error);
                this.submitted = false;
            });
        }
    }

    goTo(data) {
        this.router.navigateByUrl('consultant/' + data.id + '/appointments');
    }
}
